import { render } from "./RoleManagement.vue?vue&type=template&id=461556e4&ts=true"
import script from "./RoleManagement.vue?vue&type=script&lang=ts"
export * from "./RoleManagement.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Code\\hjp\\yijian-proxy-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__